import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const SideBar = () => {
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const location = useLocation();
 const {t}=useTranslation()
  const menuItems = [
    { path: "/", label: t("menus.dashboard") },
    { path: "/blogs", label: "Blogs" },
    { path: "/news", label: "News" },
    { path: "/restaurant", label: "Restaurant" },
    { path: "/country", label: "Country" },
    { path: "/test", label: "Test" },
    { path: "/department", label: "Departments" },
    
    
    { path: "/health-center", label: "Health Center" },
    { path: "/doctors", label: "Doctors" },
    { path: "/labs", label: "Labs" },
    { path: "/patient", label: "Patient" },
    { path: "/trading", label: "Trading" },
    { path: "/trading-category", label: "Trading-Category" },
    { path: "/faq", label: "Faq" },
    { path: "/outside-jordan", label: "Outside Jordan" },
    { path: "/other-services", label: "Other-Services" },
  ];

  const handleActiveSubMenu = (item) => {
    setActiveSubMenu((prevItem) => (prevItem === item ? null : item));
  };

  return (
    <aside
      className={`mt-[65px] bg-white text-gray-50 w-[266px] flex-shrink-0 flex flex-col h-screen sticky top-[0px] px-[15px] py-[20px] sidebar--menu ${
        activeSubMenu === "togglesidebar" ? "active--toggle" : ""
      }`}
    >
      <div className="top--logobar">
        <div
          className="toggle--bar"
          onClick={() => handleActiveSubMenu("togglesidebar")}
        >
          <FaChevronLeft
            className={`text-white bg-black rounded-[50px] p-2 w-[32px] h-[32px] duration-200 ${
              activeSubMenu === "togglesidebar" ? "rotate-[180deg]" : ""
            }`}
          />
        </div>
      </div>

      <div className="sidebar--menu--items--lists overflow-y-auto overflow-x-clip over--scroller">
        <div className="management--menu pb-[24px] mb-[24px]">
          <p className="label--menu hide--content">Management</p>
          <ul className="flex flex-col gap-[0px] menu--bar--list">
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`px-[5px] py-3 transition-colors duration-200 relative block text-black flex items-center gap-[5px] bg-white rounded-[5px] text-textcolor ${
                    location.pathname === item.path ? "active" : ""
                  }`}
                >
                  <img
                    src="/assets/images/home-icon.svg"
                    className="menu--icon"
                    alt={`${item.label} icon`}
                  />
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </aside>
  );
};

export default SideBar;
